'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _fieldInfo = require('../../selectors/field-info');
var _vehicleLookup = require('../../selectors/vehicle-lookup');
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _readOnly = require('../read-only');
var _readOnly2 = _interopRequireDefault(_readOnly);
var _formField = require('../form-field');
var _formField2 = _interopRequireDefault(_formField);
var _input = require('../input');
var _input2 = _interopRequireDefault(_input);
var _inputGroup = require('../input/input-group');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var groupStyles = function groupStyles(_ref) {
  var theme = _ref.theme;
  return {
    paddingBottom: theme.space_xs
  };
};
var Group = (0, _glamorous2.default)('div')(groupStyles);
var DetailsPanel = function (_Component) {
  _inherits(DetailsPanel, _Component);
  function DetailsPanel() {
    _classCallCheck(this, DetailsPanel);
    return _possibleConstructorReturn(this, (DetailsPanel.__proto__ || Object.getPrototypeOf(DetailsPanel)).apply(this, arguments));
  }
  _createClass(DetailsPanel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_formField2.default, {
        label: this.props.label,
        name: 'vehicleDescription'
      }, _react2.default.createElement(_readOnly2.default, null, _react2.default.createElement(Group, null, _react2.default.createElement('strong', null, 'Registration:'), _react2.default.createElement('br', null), this.props.regNo || 'UNAVAILABLE'), _react2.default.createElement(Group, null, _react2.default.createElement('strong', null, 'Description: '), _react2.default.createElement('br', null), this.props.description), _react2.default.createElement('a', {
        onClick: this.props.resetLookup
      }, this.props.reset))), _react2.default.createElement(_input2.default, {
        name: 'value',
        label: 'What is the value of the car?',
        helpText: 'Enter the estimated value of the vehicle. Remember this is the current amount you would expect to get if sold to a private buyer',
        left: _react2.default.createElement(_inputGroup.InputGroupItem, {
          text: '\xA3'
        })
      }));
    }
  }]);
  return DetailsPanel;
}(_react.Component);
DetailsPanel.propTypes = {
  formId: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired,
  resetLookup: _propTypes.func.isRequired,
  reset: _propTypes.string.isRequired,
  label: _propTypes.string.isRequired,
  regNo: _propTypes.string
};
DetailsPanel.defaultProps = {
  regNo: undefined
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    regNo: (0, _fieldInfo.getValue)(state, ownProps.formId, 'regNo'),
    description: (0, _vehicleLookup.vehicleDescription)(state, ownProps.formId)
  };
})(DetailsPanel));